import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAPIPublic, useDealer } from "../../../../../tools/api";
import { Breadcrumb, Button, Col, Form, Input, Row, Select, Steps } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { _adr } from "../../../../../address";
import { clearFormData, simcardPurchase } from "../../../../../reducer/serviceReducer";
import OTP from "../../../../auxiliary/otp-modal/otp";
import { convertPersian, fileToBase64, regexFormater, validateInput } from "../../../../../tools/tools";
import { Content } from "antd/es/layout/layout";
import { HomeOutlined } from "@ant-design/icons";
import CWLayout from "../../../../changeOwnership/change/cwLayout";
import DatePicker from "../../../../auxiliary/datepicker/datepicker";
import ReactInputMask from "react-input-mask";
import Profile from "../../profile/profile";
import { CheckTokenWithOTP, setTokenOTP } from "../../../../../tools/services";

const CowProfile = () => {
	//================ Hook =========================
	const [t] = useTranslation("global");
	const nav = useNavigate();
	const [frmProfile] = Form.useForm();
	const { queryGender, queryActiveProvince, queryCityByCityId, queryActiveCityByProvinceId, queryActiveCountry, queryCertType } = useAPIPublic();
	const { queryCountSimCardByCertNo, queryProfileByCertNoVBirthDate, addressByPostcode } = useDealer();
	const refMsisdn = useRef();

	const location = useLocation();

	const formData = useSelector((state) => state?.from?.coownership);
	const dispatch = useDispatch();

	const [prof, setProf] = useState({
		purchase: location?.state,
		profile: !location?.state ? formData?.profile : null,
		valMsisdn: "",
		isLangPersian: true,
		isIran: true,
		gender: [],
		counterSim: "-1",
		firstSimCard: false,
		country: [],
		certtype: [],
		province: [],
		city: [],
		birtday: "",
		prevBirtday: "",
		certNo: "",
		prevCertNo: "",
		postCode: "",
		prevCode: "",
		isOpenOtp: false,
	});

	//================ Hook =========================

	const handleChangeCertType = (value) => {
		if (value === 1) {
			setProf((pr) => ({ ...pr, isLangPersian: false }));
			frmProfile.setFieldValue("birthdate", "");
		} else {
			setProf((pr) => ({ ...pr, isLangPersian: true }));
		}
		if (value !== 0) {
			setProf((pr) => ({ ...pr, isIran: false }));
		} else {
			setProf((pr) => ({ ...pr, isIran: true }));
		}
	};

	//#region Initial Data Set Form =================

	useEffect(() => {
		const callServInitial = async () => {
			//Call Service Gender
			if (prof.gender.length === 0) {
				let resGender = await queryGender();
				if (resGender) {
					setProf((prev) => ({ ...prev, gender: resGender }));
				}
			}
			//cal service Country
			let resCountry = await queryActiveCountry();
			if (resCountry) {
				resCountry.sort((a, b) => {
					if (a.inT_OrderId < b.inT_OrderId) return -1;
					if (a.inT_OrderId > b.inT_OrderId) return 1;
					return 0;
				});
				setProf((prev) => ({ ...prev, country: resCountry }));
			}

			//cal certtype
			let resCertType = await queryCertType();
			if (resCertType) {
				setProf((prev) => ({ ...prev, certtype: resCertType }));
			}

			if (prof.province.length === 0) {
				//Call Service Province
				let resProvince = await queryActiveProvince();
				if (resProvince) {
					setProf((prev) => ({ ...prev, province: resProvince }));
				}
			}
		};
		callServInitial();
	}, []);
	//#endregion Initial Data Set Form =================

	//#region Load Data Draft From Reducer ===========

	useEffect(() => {
		if (prof?.profile) {
			handleCityListByProvinceId(prof?.profile?.provinceid);
			frmProfile.setFieldsValue({
				certtype: prof?.profile?.certtype,
				certno: prof?.profile?.certno,
				birthdate: prof?.profile?.birthdate,
				fname: prof?.profile?.fname,
				lname: prof?.profile?.lname,
				fathername: prof?.profile?.fathername,
				gender: prof?.profile?.gender,
				countryid: prof?.profile?.countryid,
				identityno: prof?.profile?.identityno,
				smsmobileno: prof?.profile?.smsmobileno,
				typeforupload: prof?.profile?.typeforupload,
				postalcode: prof?.profile?.postalcode,
				provinceid: prof?.profile?.provinceid,
				cityid: prof?.profile?.cityid,
				tel: prof?.profile?.tel,
				mainstreet: prof?.profile?.mainstreet,
				alley: prof?.profile?.alley,
				auxiliaryroad: prof?.profile?.auxiliaryroad,
				buildingno: prof?.profile?.buildingno,
				floor: prof?.profile?.floor,
				unit: prof?.profile?.unit,
			});
			setProf((pr) => ({ ...pr, valMsisdn: prof?.profile?.smsmobileno }));
			handleChangeCertType(prof?.profile?.certtype);
		} else {
			dispatch(clearFormData(["coownership"]));
		}
	}, [prof?.profile]);
	//#endregion Load Data Draft From Reducer ===========

	//#region Check Counter Sim card Activated =======

	const handleCountSim = async (e) => {
		setProf((pr) => ({ ...pr, certNo: e.target.value }));
		if (e.target.value.length === 10 && e.target.value !== prof?.prevCertNo) {
			let payload = {
				certno: e.target.value,
			};
			let response = await queryCountSimCardByCertNo(payload);
			if (response != null) {
				setProf((pr) => ({ ...pr, prevCertNo: e.target.value }));
				if (response === 0) {
					setProf((pr) => ({ ...pr, firstSimCard: true, counterSim: response }));
				} else {
					setProf((pr) => ({ ...pr, counterSim: response }));
				}
			}
		}
	};
	//#endregion Check Counter Sim card Activated =======

	//#region Call Service get all Cities From Province
	const handleCityListByProvinceId = async (item) => {
		let resCity = await queryActiveCityByProvinceId(item);
		if (resCity) {
			setProf((pr) => ({ ...pr, city: resCity }));
		}
	};
	//#endregion Call Service get all Cities From Province

	//#region callBack Function From Date picker ======
	const handleGetDate = (temp) => {
		frmProfile.setFieldValue("birthdate", temp);
		setProf((pr) => ({ ...pr, birtday: temp }));
	};
	//#endregion callBack Function From Date picker ======

	//#region Get Address From Service Post ===========

	//Call Service Read Postalcode From Service
	useEffect(() => {
		const CallPostalCode = async () => {
			if (prof.postCode.length === 10 && prof.postCode !== prof.prevCode) {
				let payload = {
					postCode: frmProfile.getFieldValue("postalcode"),
				};
				let resPost = await addressByPostcode(payload);
				if (resPost) {
					setProf((pr) => ({ ...pr, prevCode: prof.postCode }));
					frmProfile.setFieldsValue({
						mainstreet: resPost?.mainStreet,
						buildingno: resPost?.buildingNo,
						floor: resPost?.floor,
						alley: resPost?.alley,
						auxiliaryroad: resPost?.auxiliaryRoad,
						tel: resPost?.tel,
					});
					if (resPost?.cityId) {
						let resProvince = await queryCityByCityId(resPost?.cityId);
						if (resProvince) {
							frmProfile.setFieldsValue({
								provinceid: resProvince?.provinceid,
							});
							handleCityListByProvinceId(resProvince?.provinceid);
						}
					}
				}
			}
		};
		CallPostalCode();
	}, [prof.postCode]);
	//#endregion Get Address From Service Post ===========

	//#region Load Profile With Service ==============

	useEffect(() => {
		const handleReadProfile = async () => {
			if (prof.certNo.length === 10 && prof.birtday.length > 0) {
				if (prof.birtday !== prof.prevBirtday || prof.certNo !== prof.prevCertNo) {
					let payload = {
						certno: prof.certNo,
						birthdate: prof.birtday,
					};
					let response = await queryProfileByCertNoVBirthDate(payload);
					if (response) {
						setProf((pr) => ({ ...pr, prevBirtday: prof.birtday, prevCertNo: prof.certNo }));
						frmProfile.setFieldsValue({
							fname: response?.fname,
							lname: response?.lname,
							fathername: response?.fathername,
							gender: response?.gender,
							identityno: response?.identityno,
							smsmobileno: response?.smsmobileno.toString(),
						});
						setProf((pr) => ({ ...pr, valMsisdn: response?.smsmobileno.toString() }));
						// document.getElementById("refMsisdn")?.value = response?.smsmobileno.toString().replace("9", "");
						if (response?.address?.postalcode?.length > 0) {
							frmProfile.setFieldValue("postalcode", response?.address?.postalcode);
							setProf((pr) => ({ ...pr, postCode: response?.address?.postalcode }));
						}
					}
				}
			}
		};
		handleReadProfile();
	}, [prof.certNo, prof.birtday]);
	//#endregion Load Profile With Service ===========

	useEffect(() => {
		frmProfile.setFieldValue("smsmobileno", prof.valMsisdn);
	}, [prof.valMsisdn]);

	//#region submit Form Profile , Address and Document
	const handleSubmit = async (values) => {
		setProf((pr) => ({ ...pr, isOpenOtp: true }));
	};
	//#endregion submit Form Profile , Address and Document

	//handle Get Token From OTP Service
	const handleGetToken = async (token) => {
		try {
			setProf((pr) => ({ ...pr, isOpenOtp: false }));
			if (token) {
				// await setToken({
				//   token: token.token,
				//   expireUTCTime: token.expireUTCTime,
				// });
				// setAuthorization(token.token);

				await setTokenOTP({ expireUTCTime: token.expireUTCTime, token: token.token });
				const isTokenOTP = await CheckTokenWithOTP();
				if (isTokenOTP) {
					let txtGender = prof?.gender.find((item) => item.value === frmProfile.getFieldValue("gender"))?.name;
					let txtProvince = prof?.province.find((item) => item.inT__ProvinceId === frmProfile.getFieldValue("provinceid"))?.stR_ProvinceName;
					let txtCity = prof?.city.find((item) => item.inT_CityId === frmProfile.getFieldValue("cityid"))?.stR_CityName;
					let txtDocumentType = prof?.certtype.find((item) => item.value === frmProfile.getFieldValue("certtype"))?.name;
					let txtCountry = prof?.country.find((item) => item.inT_CountryId === frmProfile.getFieldValue("countryid"))?.stR_CountryName;

					const profileValues = frmProfile.getFieldsValue();
					const photoBase64 = await fileToBase64(profileValues.photo);
					dispatch(
						simcardPurchase({
							coownership: {
								purchase: prof.purchase,
								profile: {
									...profileValues,
									photo: photoBase64,
									txtGender,
									txtProvince,
									txtCity,
									txtDocumentType,
									txtCountry,
									isIran: prof?.isIran,
									isLangPersian: prof?.isLangPersian,
								},
							},
						}),
					);
					nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Upload);
				}
			}
		} catch (error) {
			console.error(error);
			setProf((pr) => ({ ...pr, isOpenOtp: false }));
		}
	};
	//==========================================

	return (
		<>
			<CWLayout>
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
						/>
						<div className="title-page">
							<h3>{t("changeOwnerShip.ownership.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main da-container">
						<div className="g-format-page">
							<Profile Profile={prof.purchase} state />
							<br />
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={0}
											responsive
											items={[
												{
													title: "اطلاعات خریدار(حقیقی)",
												},
												{
													title: "آپلود مدرک شناسایی (حقیقی)",
												},
												{
													title: "بررسی نهایی",
												},
											]}
										/>
									</div>
								</div>
								<div className="cw-profile">
									<h3 className="header-of-form">اطلاعات هویتی </h3>
									<Form id="frmProfile" form={frmProfile} onFinish={handleSubmit} layout="vertical">
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													name="certtype"
													className="input-normal"
													rules={[validateInput({ t: t, validate: true })]}
													label="نوع مدرک شناسایی">
													<Select onChange={handleChangeCertType}>
														{prof?.certtype.map((item, key) => (
															<Select.Option key={key} value={item.value}>
																{item.name}
															</Select.Option>
														))}
													</Select>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}></Col>
										</Row>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="certno"
													label="شماره مدرک شناسایی"
													onBlur={handleCountSim}
													onChange={(e) => {
														e.target.value = convertPersian(e.target.value);
													}}
													rules={[validateInput({ t: t, validate: true })]}
													extra={
														<>
															{prof.counterSim != -1 && (
																<>
																	{10 - prof.counterSim >= 0 ? (
																		<span className="result-sucess">
																			شما میتوانید <span>{10 - prof.counterSim}</span> سیمکارت دیگر خریداری کنید{" "}
																		</span>
																	) : (
																		<span className="result-unsucess">شما امکان خرید سیم کارت بیشتر از حد تعیین شده را ندارید</span>
																	)}
																</>
															)}
														</>
													}>
													<Input dir="ltr" inputMode="numeric" maxLength={11} autoComplete="off" />
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item className="input-normal" name="birthdate" rules={[validateInput({ t: t, validate: true })]} label="تاریخ تولد">
													<DatePicker values={frmProfile.getFieldValue("birthdate")} onChange={handleGetDate} lang={prof.isLangPersian} />
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="fname"
													label="نام"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: prof.isLangPersian ? "persian" : "english",
														}),
													]}>
													<Input
														autoComplete="off"
														dir={prof.isLangPersian ? "rtl" : "ltr"}
														onChange={(e) => (e.target.value = convertPersian(e.target.value))}
													/>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="lname"
													label="نام خانوادگی"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: prof.isLangPersian ? "persian" : "english",
														}),
													]}>
													<Input
														autoComplete="off"
														dir={prof.isLangPersian ? "rtl" : "ltr"}
														onChange={(e) => (e.target.value = convertPersian(e.target.value))}
													/>
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="fathername"
													label="نام پدر"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: prof.isLangPersian ? "persian" : "english",
														}),
													]}>
													<Input
														autoComplete="off"
														dir={prof.isLangPersian ? "rtl" : "ltr"}
														onChange={(e) => (e.target.value = convertPersian(e.target.value))}
													/>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item className="input-normal" name="gender" label="جنسیت" rules={[validateInput({ t: t, validate: true })]}>
													<Select>
														{prof?.gender.map((item, key) => (
															<Select.Option key={key} value={item.value}>
																{item.name}
															</Select.Option>
														))}
													</Select>
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={30}>
											{!prof.isIran && (
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item className="input-normal" name="countryid" label="کشور" rules={[validateInput({ t: t, validate: true })]}>
														<Select showSearch filterOption={(inputValue, option) => option.children.toString().startsWith(inputValue)}>
															{prof?.country?.map((item, key) => (
																<Select.Option key={key} value={item.inT_CountryId}>
																	{item.stR_CountryName}
																</Select.Option>
															))}
														</Select>
													</Form.Item>
												</Col>
											)}

											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="email"
													label="پست الکترونیکی"
													rules={[
														validateInput({
															t: t,
															validate: false,
															type: "email",
														}),
													]}>
													<Input dir="ltr" inputMode="email" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
												</Form.Item>
											</Col>
										</Row>
										<h3 className="header-of-form">اطلاعات تماس </h3>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="smsmobileno"
													label={prof?.firstSimCard ? "شماره معرف" : "شماره همراه"}
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "regexMsisdnFix",
														}),
													]}>
													<div>
														<ReactInputMask
															mask="0\999 99 99 999"
															id="refMsisdn"
															value={frmProfile.getFieldValue("smsmobileno")?.length > 0 ? frmProfile.getFieldValue("smsmobileno") : ""}
															// value={9991337053}
															onChange={(e) => {
																e.target.value = convertPersian(e.target.value);
																setProf((pr) => ({ ...pr, valMsisdn: e.target.value }));
															}}
															inputMode="numeric"
															className="msisdn-mask"
															dir="ltr"
														/>
													</div>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="tel"
													label="تلفن ثابت"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "number",
														}),
													]}>
													<Input
														placeholder="تلفن ثابت"
														inputMode="numeric"
														autoComplete="off"
														dir="ltr"
														onChange={(e) => (e.target.value = convertPersian(e.target.value))}
													/>
												</Form.Item>
											</Col>
										</Row>
										<h3>اطلاعات آدرس </h3>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="postalcode"
													label="کدپستی"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "number",
															length: 10,
														}),
													]}>
													<Input
														onBlur={(e) => {
															setProf((prev) => ({
																...prev,
																postCode: e.target.value,
															}));
														}}
														onChange={(e) => (e.target.value = convertPersian(e.target.value))}
														dir="ltr"
														maxLength={10}
														inputMode="numeric"
														placeholder="کدپستی خود را وارد کنید"
													/>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item className="input-normal" name="provinceid" label="استان" rules={[validateInput({ t: t, validate: true })]}>
													<Select
														filterOption={(inputValue, option) => {
															return option.children.toString().includes(inputValue.toString());
														}}
														onChange={(item, option) => {
															handleCityListByProvinceId(item);
														}}
														showSearch>
														{prof.province.map((item) => (
															<Select.Option key={item.inT__ProvinceId} value={item.inT__ProvinceId}>
																{item.stR_ProvinceName}
															</Select.Option>
														))}
													</Select>
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item className="input-normal" name="cityid" label="شهر" rules={[validateInput({ t: t, validate: true })]}>
													<Select
														filterOption={(inputValue, option) => {
															return option.children.toString().includes(inputValue.toString());
														}}
														showSearch>
														{prof?.city.map((item, key) => (
															<Select.Option key={key} value={item.inT_CityId}>
																{item.stR_CityName}
															</Select.Option>
														))}
													</Select>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="mainstreet"
													label="خیابان اصلی"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "persian",
														}),
													]}>
													<Input placeholder="خیابان اصلی" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="auxiliaryroad"
													label="خیابان فرعی"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "persian",
														}),
													]}>
													<Input placeholder="خیابان فرعی" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="alley"
													label="کوچه"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "persian",
														}),
													]}>
													<Input placeholder="کوچه" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="buildingno"
													label="پلاک"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "number",
														}),
													]}>
													<Input placeholder="پلاک" inputMode="numeric" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item className="input-normal" name="floor" label="طبقه" rules={[validateInput({ t: t, validate: true })]}>
													<Input placeholder="طبقه" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item className="input-normal" name="unit" label="واحد" rules={[validateInput({ t: t, validate: true })]}>
													<Input autoComplete="off" placeholder="واحد" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
												</Form.Item>
											</Col>
										</Row>
									</Form>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button
										disabled={10 - prof.counterSim > 0 ? false : true}
										form="frmProfile"
										key="submit"
										htmlType="submit"
										className="btn-normal btn-aptel">
										ادامه
									</Button>
									<Button
										onClick={() =>
											nav(
												_adr.Root +
													_adr.ChangeOwnerShip.Index +
													_adr.ChangeOwnerShip.OwnerShip.Index +
													_adr.ChangeOwnerShip.OwnerShip.InformationSeller,
											)
										}
										className="btn-normal">
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
				<OTP
					isOpen={prof.isOpenOtp}
					callback={handleGetToken}
					certno={frmProfile.getFieldValue("certno")}
					expiretimebyminute={process.env.REACT_APP_LOGIN_EXPIRE}
					msisdn={prof.valMsisdn?.length > 0 ? regexFormater(prof.valMsisdn?.slice(0) || " ").removeSpace() : ""}
					sessionid={Date.now()}
				/>
			</CWLayout>
		</>
	);
};

export default CowProfile;
